export default __webpack_public_path__ + "media/images/icons/handshake-b940607752bd7f0d6a4083d7094075e8.svg";